import { styled } from "@mui/material";

import { Timeline } from "./Timeline";
import { TimelineDot } from "./TimelineDot";

import type { ColorMap, TimeLineColor } from "../../constants/Timeline";

interface StatusTimelineProps {
  color: TimeLineColor;
  dotColorMap: ColorMap;
  timeLineColorMap: ColorMap;
}

export function StatusTimeline({
  color,
  timeLineColorMap,
  dotColorMap,
}: StatusTimelineProps) {
  const { lineColorGetter, dotColorGetter } = useStatusTimeline(
    color,
    dotColorMap,
    timeLineColorMap
  );

  return (
    <StatusTimelineWrapper>
      <TimelineDot colorGetter={dotColorGetter} />
      <Timeline colorGetter={lineColorGetter} />
    </StatusTimelineWrapper>
  );
}

function useStatusTimeline(
  color: TimeLineColor,
  dotColorMap: ColorMap,
  timeLineColorMap: ColorMap
) {
  const lineColorGetter = timeLineColorMap.get(color);
  const dotColorGetter = dotColorMap.get(color);

  return { lineColorGetter, dotColorGetter };
}

export function StatusTimelineSkeleton() {
  return (
    <StatusTimelineWrapper>
      <TimelineDot />
      <Timeline />
    </StatusTimelineWrapper>
  );
}

const StatusTimelineWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  justifyContent: "center",
  display: "flex",
  margin: theme.spacing(1, 0.25, 0, 0),
  width: STATUS_TIMELINE_WRAPPER_WIDTH,
}));

const STATUS_TIMELINE_WRAPPER_WIDTH = 40;
